

const energyData = [
  { name: "Choisir une énergie", id: "choice" },
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];

const consoUnitData = [
  { name: "kWh", id: "electricity" },
  { name: "kWh", id: "gas" },
  { name: "m3", id: "water" },
  { name: "MWh", id: "heat" },
  { name: "MWh", id: "cold" },
  { name: "kg", id: "propane" },
  { name: "L", id: "fuel" },
  { name: "", id: "wood" },
];

const naturebudgetaire = [
  { name: "60612", id: "electricity" },
  { name: "60612", id: "gas" },
  { name: "60611", id: "water" },
  { name: "60613", id: "heat" },
  { name: "60612", id: "cold" },
  { name: "60621", id: "propane" },
  { name: "60621", id: "fuel" },
  { name: "60621", id: "wood" },

]

const billcanceled = [
  { id: "canceled", name: "Annulée" },
  { id: "validated", name: "Validée" }
]

const sources = [
  { id: "api", name: "API" },
  { id: "fileimport", name: "Import de fichier" }
]

const listcontainscomparator = [
  {
    id: "containsone",
    name: "Contient",
  }
]


const isisnotcomparator = [
  {
    id: "is",
    name: "Est",
  },
  {
    id: "isnot",
    name: "N'est pas",
  }
]

const textcomparator = [
  {
    id: "equals",
    name: "Est",
  },
  {
    id: "beginswith",
    name: "Commence par",
  },
  {
    id: "endswith",
    name: "Fini par",
  },
  {
    id: "contains",
    name: "Contient",
  },
  {
    id: "notcontains",
    name: "Ne contient pas",
  }
]

const datecomparator = [
  {
    id: "equals",
    name: "Est le",
  },
  {
    id: "before",
    name: "Est avant le",
  },
  {
    id: "after",
    name: "Est après le",
  }
]

const numbercomparator = [
  {
    id: "equals",
    name: "=",
  },
  {
    id: "lower",
    name: "<",
  },
  {
    id: "lowerequals",
    name: "<=",
  },
  {
    id: "greater",
    name: ">",
  },
  {
    id: "greaterequals",
    name: ">=",
  }
]

const listcountcomparator = [
  {
    id: "equals",
    name: "=",
  },
  {
    id: "lower",
    name: "<",
  },
  {
    id: "lowerequals",
    name: "<=",
  },
  {
    id: "greater",
    name: ">",
  },
  {
    id: "greaterequals",
    name: ">=",
  }
]

const filtersData = [
  // {
  //   id: "energy",
  //   name: "Energie",
  //   comparator: isisnotcomparator,
  //   datatype: "select",
  //   data: energyData
  // },
  {
    id: "pdl",
    name: "N° de PDL",
    comparator: textcomparator,
    datatype: "text",
  },
  {
    id: "sender",
    name: "Fournisseur",
    comparator: textcomparator,
    datatype: "text",
  },
  // {
  //   id: "source",
  //   name: "Source",
  //   comparator: isisnotcomparator,
  //   datatype: "select",
  //   data: sources
  // },
  {
    id: "docreference",
    name: "N° de facture",
    comparator: textcomparator,
    datatype: "text",
  },
  {
    id: "billdate",
    name: "Date de facture",
    comparator: datecomparator,
    datatype: "date",
  },
  {
    id: "begin",
    name: "Date de début",
    comparator: datecomparator,
    datatype: "date",
  },
  {
    id: "end",
    name: "Date de fin",
    comparator: datecomparator,
    datatype: "date",
  },
  // {
  //   id: "conso",
  //   name: "Consommation",
  //   comparator: numbercomparator,
  //   datatype: "number",
  // },
  // {
  //   id: "ttc",
  //   name: "Montant € TTC",
  //   comparator: numbercomparator,
  //   datatype: "number",
  // },
  // {
  //   id: "consogrouped",
  //   name: "Consommation du groupement",
  //   comparator: numbercomparator,
  //   datatype: "number",
  // },
  // {
  //   id: "ttcgrouped",
  //   name: "Montant € TTC du groupement",
  //   comparator: numbercomparator,
  //   datatype: "number",
  // }
]

const displaymethodData = [
  {
    id: "docreference",
    name: "Grouper par numéro de document",
  },
  {
    id: "pdl",
    name: "Grouper par numéro de PDL",
  }
]

const displayBillsColumnsData = {
  electricity : [
    {
      id: "700",
      name: "Total consommation"
    },
    {
      id: "718",
      name: "Total énergie facturée €"
    },
    {
      id: "720",
      name: "Total TURPE €",
    },
    {
      id: "825",
      name: "Total Taxes €",
    },
    {
      id: "724",
      name: "Total HTVA €",
    },
    {
      id: "726",
      name: "TVA - Taux réduit €",
    },
    {
      id: "727",
      name: "TVA - Taux normal €",
    },
    {
      id: "728",
      name: "TVA €",
    },
    {
      id: "729",
      name: "Total TTC €",
    },
    
    {
      id: "717",
      name: "Prix moyen kWh c€/kWh",
    },
    {
      id: "722",
      name: "CSPE €",
    },
    {
      id: "1047",
      name: "Taux CSPE c€/kWh",
    },
    {
      id: "723",
      name: "CTA €",
    },
    {
      id: "1071",
      name: "TCCFE €",
    },
    {
      id: "1070",
      name: "Taux TCCFE c€/kWh",
    },
    {
      id: "1062",
      name: "TDCFE €",
    },
    {
      id: "1061",
      name: "Taux TDCFE c€/kWh",
    },
    {
      id: "684",
      name: "Consommation Base",
    },
    {
      id: "693",
      name: "Consommation HP",
    },
    {
      id: "694",
      name: "Consommation HC",
    },
    {
      id: "690",
      name: "Consommation HPB",
    },
    {
      id: "691",
      name: "Consommation HCB",
    },
    {
      id: "686",
      name: "Consommation HPH",
    },
    {
      id: "687",
      name: "Consommation HCH",
    },
    {
      id: "685",
      name: "Consommation Pointe",
    },
    {
      id: "701",
      name: "Energie facturée Base",
    },
    {
      id: "944",
      name: "Taux kWh Base c€/kWh",
    },
    {
      id: "710",
      name: "Energie facturée HP",
    },
    {
      id: "953",
      name: "Taux kWh HP c€/kWh",
    },
    {
      id: "711",
      name: "Energie facturée HC",
    },
    {
      id: "954",
      name: "Taux kWh HC c€/kWh",
    },
    {
      id: "707",
      name: "Energie facturée HPB",
    },
    {
      id: "950",
      name: "Taux kWh HPB c€/kWh",
    },
    {
      id: "708",
      name: "Energie facturée HCB",
    },
    {
      id: "951",
      name: "Taux kWh HCB c€/kWh",
    },
    {
      id: "703",
      name: "Energie facturée HPH",
    },
    {
      id: "946",
      name: "Taux kWh HPH c€/kWh",
    },
    {
      id: "704",
      name: "Energie facturée HCH",
    },
    {
      id: "947",
      name: "Taux kWh HCH c€/kWh",
    },
    {
      id: "702",
      name: "Energie facturée Pointe",
    },
    {
      id: "945",
      name: "Taux kWh Pointe c€/kWh",
    },
    {
      id: "1432",
      name: "ENEDIS - Total TURPE €",
    },
    {
      id: "1433",
      name: "ENEDIS - Total TURPE €CTA €",
    },
    {
      id: "1430",
      name: "ENEDIS - Total TURPE €Total HTVA €",
    },
    {
      id: "1429",
      name: "ENEDIS - Total TURPE €TVA €",
    },
    {
      id: "1431",
      name: "ENEDIS - Total TURPE €Total TTC €",
    }
  ],
  gas : [
    {
      id: "828",
      name: "Total consommation kWh"
    },
    {
      id: "830",
      name: "Total énergie facturée €"
    },
    {
      id: "1365",
      name: "Total Transport €",
    },
    {
      id: "920",
      name: "Total Taxes €",
    },
    {
      id: "831",
      name: "Total HTVA €",
    },
    {
      id: "1373",
      name: "TVA €",
    },
    {
      id: "832",
      name: "Total TTC €",
    },
    {
      id: "1363",
      name: "Prix moyen kWh c€/kWh",
    },
    {
      id: "1368",
      name: "TICGN €",
    },
    {
      id: "1370",
      name: "CTA €",
    },
  ],
  water : [
    {
      id: "1374",
      name: "Total consommation m3"
    },
    {
      id: "1376",
      name: "Total eau facturée €"
    },
    {
      id: "1377",
      name: "Total assainissement €",
    },
    {
      id: "1378",
      name: "Total distribution €",
    },
    {
      id: "1379",
      name: "Total organismes publics €",
    },
    {
      id: "923",
      name: "Abonnement €",
    },
    {
      id: "837",
      name: "Total HTVA €",
    },
    {
      id: "1383",
      name: "TVA €",
    },
    {
      id: "838",
      name: "Total TTC €",
    },
    {
      id: "1375",
      name: "Prix moyen m3 c€/m3",
    },
  ],
  heat : [
    {
      id: "918",
      name: "Total consommation MWh"
    },
    {
      id: "914",
      name: "Total énergie facturée €"
    },
    {
      id: "915",
      name: "Abonnement €",
    },
    {
      id: "1418",
      name: "Total HTVA €",
    },
    {
      id: "1421",
      name: "TVA €",
    },
    {
      id: "916",
      name: "Total TTC €",
    },
  ],
  cold : [
    {
      id: "905",
      name: "Total consommation MWh"
    },
    {
      id: "908",
      name: "Total énergie facturée €"
    },
    {
      id: "911",
      name: "Abonnement €",
    },
    {
      id: "1422",
      name: "Total HTVA €",
    },
    {
      id: "1425",
      name: "TVA €",
    },
    {
      id: "910",
      name: "Total TTC €",
    },
  ],
  fuel : [
    {
      id: "1317",
      name: "Total consommation L"
    },
    {
      id: "1318",
      name: "Total consommation facturée €"
    },
    {
      id: "1319",
      name: "Abonnement €",
    },
    {
      id: "1323",
      name: "TICPE €",
    },
    {
      id: "1325",
      name: "Taxes locales ou Contributions €",
    },
    {
      id: "1329",
      name: "Total HTVA €",
    },
    {
      id: "1328",
      name: "TVA €",
    },
    {
      id: "1330",
      name: "Total TTC €",
    },
    {
      id: "1426",
      name: "Consommation totale équivalente kWh",
    },
  ],
  propane : [
    {
      id: "1345",
      name: "Total consommation kg"
    },
    {
      id: "1346",
      name: "Total consommation facturée €"
    },
    {
      id: "1347",
      name: "Abonnement €",
    },
    {
      id: "1351",
      name: "TICPE €",
    },
    {
      id: "1353",
      name: "Taxes locales ou Contributions €",
    },
    {
      id: "1357",
      name: "Total HTVA €",
    },
    {
      id: "1356",
      name: "TVA €",
    },
    {
      id: "1358",
      name: "Total TTC €",
    },
    {
      id: "1427",
      name: "Consommation totale équivalente kWh",
    },
  ],
  wood : [
    {
      id: "1331",
      name: "Total consommation"
    },
    {
      id: "1332",
      name: "Total consommation facturée €"
    },
    {
      id: "1333",
      name: "Abonnement €",
    },
    {
      id: "1337",
      name: "TICPE €",
    },
    {
      id: "1339",
      name: "Taxes locales ou Contributions €",
    },
    {
      id: "1343",
      name: "Total HTVA €",
    },
    {
      id: "1342",
      name: "TVA €",
    },
    {
      id: "1344",
      name: "Total TTC €",
    },
    {
      id: "1428",
      name: "Consommation totale équivalente kWh",
    },
    {
      id: "1457",
      name: "Taux d'humidité %",
    },
  ]

}


export { billcanceled, energyData, naturebudgetaire, sources, consoUnitData, filtersData, displaymethodData, displayBillsColumnsData };
